const actions = {
  FETCH_USER_DETAIL: 'userprofile/FETCH_USER_DETAIL',
  FETCH_INTERNAL_USER_LIST: 'userprofile/FETCH_INTERNAL_USER_LIST',
  UPDATE_USER: 'userprofile/UPDATE_USER',
  CHANGE_PASSWORD: 'userprofile/CHANGE_PASSWORD',
  CREATE_USER: 'userprofile/CREATE_USER',
}

export default actions
